module.exports = __webpack_public_path__ + "img/interpackmaxi_dfod_dg.09d09116.png";